var _path, _circle, _circle2, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconShippingTruck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.00894 20.8678C2.92901 21.4673 3.39538 22 4.00017 22H5.85798C5.85995 22 5.86157 22.0016 5.86167 22.0035C5.93787 23.5135 7.18626 24.7143 8.71513 24.7143C9.9153 24.7143 10.9426 23.9743 11.3658 22.9257C11.5653 22.4312 11.9876 22 12.5207 22H20.3382C20.8714 22 21.2937 22.4312 21.4932 22.9257C21.9163 23.9743 22.9437 24.7143 24.1438 24.7143C25.344 24.7143 26.3714 23.9743 26.7945 22.9257C26.994 22.4312 27.4163 22 27.9494 22H27.9907C28.4883 22 28.9103 21.6341 28.9806 21.1414L29.8078 15.3515C29.8403 15.1241 29.7935 14.8925 29.6753 14.6956L27.1493 10.4855C26.9686 10.1843 26.6431 10 26.2918 10H21.5384C20.9205 10 20.4505 9.44513 20.552 8.8356L20.6639 8.1644C20.7655 7.55487 20.2955 7 19.6775 7H5.7335C5.2323 7 4.80851 7.37103 4.74227 7.86784L3.00894 20.8678Z",
    fill: "#F5DADF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.2868,
    cy: 21.8571,
    r: 2.85714,
    stroke: "#2D2926",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.85714,
    cy: 21.8571,
    r: 2.85714,
    stroke: "#2D2926",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 16H7.28571",
    stroke: "#2D2926",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 11H11",
    stroke: "#2D2926",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.14453 7H21.1445L19.1445 22H12.001M3.14453 22H6.00098",
    stroke: "#2D2926",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22 21.8571H19L20.7143 10H27L30 14.8571L29 21.8571H27",
    stroke: "#2D2926",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShippingTruck);
export default __webpack_public_path__ + "static/media/iconShippingTruck.0312e4a6ae41565cfd882c3ef0c3278c.svg";
export { ForwardRef as ReactComponent };